import React from 'react';
import { Button, Dropdown } from 'antd';
import { GlobalOutlined, DownOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { setLocale, type AppLocale } from '../i18n';

const ITEMS = [
  { key: 'ru', label: 'Русский (RU)' },
  { key: 'en', label: 'English (EN)' },
  { key: 'uk', label: 'Українська (UK)' },
];

const LanguageSwitcher: React.FC = () => {
  const { i18n } = useTranslation();
  const current = (i18n.language as AppLocale) || 'ru';

  return (
    <Dropdown
      menu={{
        items: ITEMS,
        selectedKeys: [current],
        onClick: ({ key }) => setLocale(key as AppLocale),
      }}
      trigger={['click']}
    >
      <Button size="small" type="text" style={{ color: '#fff' }}>
        <GlobalOutlined /> {current.toUpperCase()} <DownOutlined />
      </Button>
    </Dropdown>
  );
};

export default LanguageSwitcher;
